export const IAMUserPrefix = 'U-'; // Unified User ID
export const AccountGroupPrefix = 'AG-'; // Unified User ID

export const CustomerPrefix = 'CUSTOMER-';
export const ContactPrefix = 'CONTACT-';

export const getSMSSettingUrl = (accoungGroupId: string): string => {
  return `/account/location/${accoungGroupId}/settings/inbox/sms-registration`;
};
